/**
 * IP + tarayıcı diline göre otomatik ülke/dil — Shopify native API, harici app yok.
 * https://shopify.dev/docs/storefronts/themes/markets/localization-discovery
 */
(function () {
  const STORAGE_KEY = 'aycan-localize-done';
  if (sessionStorage.getItem(STORAGE_KEY)) return;

  const root = window.Shopify?.routes?.root || '/';
  const currentCountry = window.Shopify?.country || '';
  const currentLanguage = window.Shopify?.locale || document.documentElement.lang?.split('-')[0] || 'en';

  const params = new URLSearchParams({
    'country[enabled]': 'true',
    'country[exclude]': currentCountry,
    'language[enabled]': 'true',
    'language[exclude]': currentLanguage,
  });

  fetch(`${root}browsing_context_suggestions.json?${params}`)
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (!data?.suggestions?.length) return;

      const best = data.suggestions[0];
      const parts = best.parts || {};
      const country = parts.country?.handle;
      const language = parts.language?.handle;
      const confidence = best.confidence ?? 0;

      // Yüksek güven — sessiz yönlendirme; düşükse kullanıcı header'dan seçer
      if (confidence < 0.85) return;
      if (!country && !language) return;

      sessionStorage.setItem(STORAGE_KEY, '1');

      const formId = 'aycan-localize-form';
      if (document.getElementById(formId)) return;

      const form = document.createElement('form');
      form.id = formId;
      form.method = 'POST';
      form.action = `${root}localization`;
      form.hidden = true;

      const returnUrl = new URL(window.location.href);
      returnUrl.searchParams.delete('country');

      const fields = {
        _method: 'PUT',
        form_type: 'localization',
        utf8: '✓',
        return_to: returnUrl.pathname + returnUrl.search,
      };
      if (country) fields.country_code = country;
      if (language) fields.locale_code = language;

      Object.entries(fields).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    })
    .catch(() => {
      /* sessiz — geo başarısızsa varsayılan dil kalır */
    });
})();
